import { render, staticRenderFns } from "./SHOrderCardSkeleton.vue?vue&type=template&id=a68ca38c&"
import script from "./SHOrderCardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SHOrderCardSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports